import { PDFDownloadLink } from '@react-pdf/renderer';
import React from 'react';
import Dashboard from './MMI-Dashboard/Dashboard';

const DownloadDashboard = ({ className, covers, fileName, title }) => {
	return (
		<div className={className}>
			<PDFDownloadLink
				document={<Dashboard covers={covers} title={title} />}
				fileName={`${fileName}.pdf`}>
				{({ blob, url, loading, error }) => {
					if (error) return null;
					return loading ? null : (
						<div className='btn btn-danger'>
							<i className='fas fa-file-pdf me-2'></i>
							<span>Download PDF</span>
						</div>
					);
				}}
			</PDFDownloadLink>
		</div>
	);
};

export default DownloadDashboard;
